import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
   // styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
    isActive = false;
    showMenu = '';

    constructor(private router: Router){

    }

     ngOnInit() {
console.log(window.location.href.indexOf("admin/advertisers/activeAdvertisement") );
 if(window.location.href.indexOf("admin/users") > -1){
         this.reload();
 }
  else if(window.location.href.indexOf("admin/advertisers") > -1 &&
 window.location.href.indexOf("admin/advertisers/activeAdvertisement") == -1){
          this.reloadAdv();
  }
    else if(window.location.href.indexOf("admin/keywords") > -1){

           this.reloadKey();
    }
      else if(window.location.href.indexOf("admin/phrases") > -1){

           this.reloadPhrase();
    }
           else if(window.location.href.indexOf("admin/segments") > -1&&
 window.location.href.indexOf("admin/segments/updatesegments") == -1 &&
  window.location.href.indexOf("admin/segments/createsegments") == -1){
            this.reloadSeg();
        }
                   else if(window.location.href.indexOf("admin/prices/users") > -1){
             this.reloadBaseUsers();
                   }
           else if(window.location.href.indexOf("admin/prices/state") > -1){
 
              this.reloadBaseState();
           }
  else if(window.location.href.indexOf("admin/prices/pricegroup") > -1){
               this.reloadPriceGroup();
  }
 else if(window.location.href.indexOf("admin/reportedcontent") > -1 &&
 window.location.href.indexOf("admin/reportedcontent/usersreported") == -1){
                this.reloadReported();
 }
   else if(window.location.href.indexOf("admin/activeAdvertisements") > -1){
                this.reloadActiveAdver();
   }
 else if(window.location.href.indexOf("admin/couponCodes") > -1
 &&  window.location.href.indexOf("admin/couponCodes/createCoupon") == -1 &&
 window.location.href.indexOf("admin/couponCodes/audience") == -1 &&
 window.location.href.indexOf("admin/couponCodes/branches") == -1 &&
 window.location.href.indexOf("admin/couponCodes/companyInfo") == -1 &&
 window.location.href.indexOf("admin/couponCodes/branchInfo") == -1 ){
                this.reloadCouponCodes();
   }

    else if(window.location.href.indexOf("admin/transaction") > -1){
                this.goToTransaction();
   }

    else if(window.location.href.indexOf("admin/companyDetails") > -1){
                this.goToCompany();
   }

   else if(window.location.href.indexOf("admin/payment") > -1){
    var element = document.getElementById('payment');
        element.classList.add("otherclass");
  }
  }
    eventCalled() {
        this.isActive = !this.isActive;
    }
    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }

    changeCss(){
       var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 

    }

    reload(){
        var element = document.getElementById('sideColor');
        element.classList.add("otherclass");

        var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");
  var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");
       
 this.router.navigate(['admin/users']);

        
    }

       reloadAdv(){

var element = document.getElementById('sideColorAdv');
        element.classList.add("otherclass");

            var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/advertisers']);

        
    }

      reloadKey(){

          var element = document.getElementById('sideColorKey');
        element.classList.add("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

    var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");
          
 this.router.navigate(['admin/keywords']);


    }

     reloadPhrase(){

 var element = document.getElementById('sideColorPhrase');
        element.classList.add("otherclass");

          var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

    var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");
          
 this.router.navigate(['admin/phrases']);


    }


    reloadSeg(){

var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorSeg');
        element.classList.add("otherclass");

          var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

  var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

 var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/segments']);
 
        
    }

    reloadBaseUsers(){
        var element = document.getElementById('sideColorBaseUsers');
        element.classList.add("otherclass");

        var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");
      
        var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/prices/users']);

    }

      reloadBaseState(){
          var element = document.getElementById('sideColorBaseState');
        element.classList.add("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/prices/state']);

    }

      reloadPriceGroup(){
          var element = document.getElementById('sideColorPrice');
        element.classList.add("otherclass");
 var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

  var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");
 var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/prices/pricegroup']);

    }

      reloadReported(){
          var element = document.getElementById('sideColorReported');
        element.classList.add("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");
        
          var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

 var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/reportedcontent']);

    }

      reloadActiveAdver(){
          var element = document.getElementById('sideColorActive');
        element.classList.add("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");
  var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

 var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/activeAdvertisements']);

        
    }
    
    reloadCouponCodes(){
       var element = document.getElementById('sideColorCoupon');
        element.classList.add("otherclass");

 var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

  var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");

 var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");

 this.router.navigate(['admin/couponCodes']);
    }
    goToTransaction() {

       var element = document.getElementById('sideColorTransaction');
        element.classList.add("otherclass");

       var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

 var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorCompany');
        element.classList.remove("otherclass");
        
      this.router.navigate(['admin/transaction']);
    }

    goToCompany(){
       var element = document.getElementById('sideColorCompany');
        element.classList.add("otherclass");

       var element = document.getElementById('sideColorCoupon');
        element.classList.remove("otherclass");

 var element = document.getElementById('sideColorActive');
        element.classList.remove("otherclass");

           var element = document.getElementById('sideColorAdv');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorKey');
        element.classList.remove("otherclass");

        var element = document.getElementById('sideColorPhrase');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorSeg');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseUsers');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorBaseState');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorPrice');
        element.classList.remove("otherclass");

          var element = document.getElementById('sideColorReported');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColor');
        element.classList.remove("otherclass");

         var element = document.getElementById('sideColorTransaction');
        element.classList.remove("otherclass");
        
      this.router.navigate(['admin/companyDetails']);
    }
  
    goToAdvertiserUpload(){
      this.router.navigate(['admin/advertiserUpload']);
    }

    goToStateForPayment(){
      this.router.navigate(['admin/payment']);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/shared/components/sidebar/sidebar.component.ts